import React from 'react';
import { useSelector } from 'react-redux';
import {
    Box,
    Button,
    FormControl,
    InputLabel,
    Select,
    Typography,
} from "@mui/material";
import { getAssignableRoles, canModifyEmployeeByRoleName } from '../../permissions/roleUtils';
import { useRoles } from '../../hooks/useRoles';
import { useAdminCompany } from '../../context/AdminCompanyContext';
import { useUpdateUserRole } from '../../hooks/useCompanyUsers';
import "./Users.css";
import Toast from '../../components/Toast';

const UserRoleChange = React.forwardRef(function UserRoleChange({item, style, page, companyData}, ref) {
    const authenticated = useSelector((state) => state.UserReducer.isAuthenticated);
    const { data: allRoles = [] } = useRoles();
    const company = useSelector((state) => state.CompanyReducer.userCompanies[0]);
    const { companyData: selectedCompany } = useAdminCompany();
    const updateUserRole = useUpdateUserRole();
    const [selectedRoleId, setSelectedRoleId] = React.useState('');
    const roleOptions = getAssignableRoles(authenticated, allRoles);
    const canModify = canModifyEmployeeByRoleName(authenticated, allRoles, item?.userRole);
    const companyId = companyData?.id ?? selectedCompany?.id ?? company?.id;

    function handleChangeRole(event) {
        setSelectedRoleId(event.target.value);
    }

    function updateUserRoleHandler(item){
        if (selectedRoleId) {
            const payload = {
                UserId: item.userId,
                RoleId: selectedRoleId,
                CompanyId: companyId,
            };
            updateUserRole.mutate(payload);
            setSelectedRoleId('');
        } else {
            Toast.fire({
                title: 'Please Select Role',
                icon: 'warning'
            })
        }
    }

    return(
        <Box ref={ref} sx={style} className="statusBox">
            <Typography>Set Employee Role</Typography>
            {!canModify ? (
                <Typography sx={{ m: 2 }}>
                    You cannot change the role of a user with a higher role than yours.
                </Typography>
            ) : (
            <Box component="form" sx={{ display: 'flex', flexWrap: 'wrap' }}>
                <FormControl sx={{ m: 2, minWidth: 120 }}>
                    <InputLabel shrink htmlFor="employee-role-select">Role</InputLabel>
                    <Select
                        native
                        inputProps={{ id: 'employee-role-select' }}
                        value={selectedRoleId}
                        onChange={handleChangeRole}
                    >
                        <option value="">Select one</option>
                        {roleOptions.map((role) => (
                            <option key={role.id} value={role.id}>
                                {role.name}
                            </option>
                        ))}
                    </Select>
                    <Button onClick={()=>updateUserRoleHandler(item)}>Update</Button>
                </FormControl>
            </Box>
            )}
        </Box>
    )
});

export default UserRoleChange;
